<template>
  <v-row class="web-info pa-0 ma-0">
    <v-col
      :class="
        $vuetify.display.lgAndUp
          ? 'text-center secondary--text pa-1'
          : 'text-center secondary--text'
      "
      cols="12"
    >
      <i18n-t tag="span" keypath="footer.web_info.host" scope="global">
        <template v-slot:link>
          <a
            href="https://www.ist.com/no/"
            target="_blank"
            style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
            >IST</a
          >
        </template>
      </i18n-t>
    </v-col>
    <v-col
      :class="
        $vuetify.display.lgAndUp
          ? 'text-center secondary--text pa-1'
          : 'text-center secondary--text'
      "
      cols="12"
    >
      <i18n-t tag="span" keypath="footer.web_info.header" scope="global">
        <template v-slot:link>
          <a
            href="https://vigo.no/nyvigo/documents/Personvernerklæring_VIGO.pdf"
            target="_blank"
            style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
          >
            {{ t('footer.web_info.gdpr') }}
          </a>
          og
          <a
            :href="`https://uustatus.no/${uuStatusLocale}/erklaringer/publisert/d88edec5-d9b2-4d71-a9d6-6066c86844b6`"
            target="_blank"
            style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
          >
            {{ t('footer.web_info.availability') }} </a
          >.
          <a
            style="font-weight: bold; color: white; text-decoration: underline; cursor: pointer"
            href="mailto:post@novari.no?subject=Tilbakemelding Lærlingtorget"
          >
            {{ t('footer.web_info.feedback') }}
          </a>
        </template>
      </i18n-t>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { getGlobalLocale } from '@/i18n'

const { t } = useI18n()

const uuStatusLocale = computed(() => (getGlobalLocale() === 'nn' ? 'nn' : 'nb'))
</script>
